<template>
  <div class="col-md-6 col-sm-6 col-xs-6 q-pl-sm">
    <q-table
      style="height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      dense
      :rows="listaChecklist"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo q-mt-sm"
      :rows-per-page-options="[0]"
      hide-pagination
      hide-bottom
      no-data-label
      @request="handleRequest"
    >
      <template v-slot:top>
        <section class="row align">
          <div class="row">
            <span class="text-h6 text-brand-5 col">
              Listagem checagem de Ferramentas
            </span>
          </div>

          <q-input
            class="q-pl-md col"
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </section>
      </template>
      <template #body-cell-selecione="props">
        <q-td>
          <q-checkbox v-model="selecionados" :val="props.row" />
        </q-td>
      </template>
      <template #body-cell-vinculados="props">
        <q-td>
          <q-btn
            class="q-ml-lg"
            round
            size="sm"
            color="primary"
            icon="visibility"
            @click="getFerramentasVinculadas(props.row.id)"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selecionados = ref([]);
    const listaUnidades = ref([]);
    const listaChecklist = ref([]);
    const selecionaImagem = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const columns = [
      {
        name: "selecione",
        label: "Selecionar",
        field: "selecione",
        align: "left",
      },
      {
        name: "descricao",
        label: "Verificações",
        field: "descricao",
        align: "left",
      },
    ];

    let listarChecklists = async () => {
      if (props.atualizar == "" || props.atualizar == undefined) {
        listaChecklist.value = [];
        return;
      }
      disable.value = true;

      try {
        let resposta = await store.dispatch("fer/listarChecklist2", {
          unidadeId: store.state.org.unidadeData.id,
        });

        listaChecklist.value = resposta.resposta.data.result;

        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => selecionados.value,
      () => {
        emit("usuariosSelecionados", selecionados.value);
      }
    );

    watch(
      () => filter.value,
      () => {
        listarChecklists();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarChecklists();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarChecklists();
      }
    );

    const handleRequest = async () => {
      listarChecklists(pagination.value.page, pagination.value.rowsPerPage);
    };

    const detalhes = async (value) => {
      router.push({
        name: "movimentarStatusFerramentaDetalhes",
        params: { id: value },
      });
    };

    const getFerramentasVinculadas = async (value) => {
      let resposta = await store.dispatch("fer/getUsuarioFerramentaVinculo", {
        user_id: value,
      });

      emit("vinculados", resposta.data.result);
      emit("userDesvincularId", value);
    };

    return {
      unidade,
      selecionaImagem,
      listaChecklist,
      listaUnidades,
      columns,
      selecionados,
      disable,
      filter,
      handleRequest,
      pagination,

      getFerramentasVinculadas,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      detalhes,
    };
  },
};
</script>
